import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, /*IconButton,*/ Link, Stack, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { getRouteFromContext } from "../../common/utilities/RouteHelpers";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { IRoute/*, routes*/ } from "../../routes/routes";
import AdministrationListUtils, { AdministrationListItemHeader } from "./AdministrationListUtils";
import { IKeyValuePair } from "../../common/models/KeyValuePair";
import useNavigateTo, { NavigateToOptions } from "../../hooks/use-navigate-to/useNavigateTo";
import { NewViewTypeEnum } from "../../common/enums/NewViewTypeEnum";

export enum AdministrationListActionEnum {
    ToggleExpansion = 1,
}

export type AdministrationListItemProps = {
    item?: IKeyValuePair<UIViewEnum, IRoute[]>,
    headerInfo?: AdministrationListItemHeader,
    onClick?: () => void
};

export function AdministrationListItem({
    item,
    headerInfo,
    onClick

}: AdministrationListItemProps) {
    const theme = useTheme();

    //const [expanded, setExpanded] = useState(item !== undefined);
    const [expanded, setExpanded] = useState(false);
    const routeContext = useRouteContext();
    const navigateTo = useNavigateTo();
    const header = item !== undefined  ? AdministrationListUtils.getHeaderInfo(item.Key) : headerInfo;
    const items = item?.Value ?? [];

    function toggleExpanded() {
        if (items.length > 0) {
            setExpanded(!expanded);
        }
    }

    const onNavigate = (item: IRoute, shiftKey: boolean, ctrlKey: boolean) => {


        let options: NavigateToOptions | undefined;

        if (shiftKey || ctrlKey) {
            options = {
                newViewType: shiftKey ? NewViewTypeEnum.NewWindow : NewViewTypeEnum.NewTab
            }
        }

        const url = getRouteFromContext(item.viewID as UIViewEnum, routeContext);
        navigateTo(url, options);
    }

    return (
        <Box sx={{
                marginLeft: theme.spacing(1), 
                marginRight: theme.spacing(1),
                    marginTop: theme.spacing(2)

                }}>
            <Accordion expanded={expanded} onChange={() => toggleExpanded()}>
                <AccordionSummary
                    id="admin-item-header"
                    expandIcon={items.length > 0 ? 
                        // <IconButton size="medium" onClick={() => toggleExpanded()}>
                            <ExpandMoreIcon sx={{ cursor: "pointer" }}/>
                        // </IconButton>
                    : undefined}
                    aria-controls="admin-item-content"
                    sx={{
                        '&:hover': {
                            cursor: 'auto!important',
                        },
                    }}

                    // onClick={() => onClick && onClick()}
                    >

                    <Stack direction='row'
                        sx={{
                            '&:hover': {
                                //cursor: onClick ? 'pointer' : undefined,
                                cursor: 'pointer'
                            },
                        }}
                        onClick={() => { 
                            if (onClick) {
                                onClick();
                            } else {
                                toggleExpanded();
                            }
                        }}
                    >
                        <Box sx={{marginRight: theme.spacing(1)}}>
                            {header?.icon}
                        </Box>  
                        <Typography
                            sx={{
                                display: 'flex',
                                fontWeight: 500,
                                fontSize: '1.1rem'
                            }}>
                            {header?.title}
                        </Typography>
                    </Stack>

                </AccordionSummary>

                {items.length > 0 && 
                <AccordionDetails 
                    id='admin-item-content' 
                    sx={{
                        display: 'flex', 
                        flexDirection: 'column', 
                        marginTop: 0, 
                        paddingLeft: theme.spacing(6)
                        }}>


                    <Grid container 
                        columns={{ xs: 2, sm: 8, md: 12 }}
                        sx={{
                            marginTop: -3
                        }}
                    >


                    {items.map((v, index) =>
                        <Grid
                            key={index}
                            sx={{
                                marginTop: theme.spacing(1),
                                paddingTop: '0!important'
                            }}
                            size={{
                                xs: 2,
                                sm: 4,
                                md: 4
                            }}>
                            <Link
                                sx={{
                                    display: 'inline-flex',
                                    color: theme.palette.text.primary,
                                    textDecoration: 'none',
                                    '&:hover': {
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                    },
                                    whiteSpace: 'nowrap',
                                    padding: .5
                                }}
                                aria-label={`navigate to ${v.name}`}
                                onClick={(ev) => onNavigate(v, ev.shiftKey, ev.ctrlKey)}>
                                {v.name}
                            </Link>
                            </Grid>

                            )}
                        </Grid>  

                </AccordionDetails>
                }
            </Accordion>
        </Box>
    );
}
